
namespace GeniuzPOS.Lookups {

    @Serenity.Decorators.registerClass()
    export class LookupTxtColorGrid extends Serenity.EntityGrid<LookupTxtColorRow, any> {
        protected getColumnsKey() { return LookupTxtColorColumns.columnsKey; }
        protected getDialogType() { return LookupTxtColorDialog; }
        protected getIdProperty() { return LookupTxtColorRow.idProperty; }
        protected getInsertPermission() { return LookupTxtColorRow.insertPermission; }
        protected getLocalTextPrefix() { return LookupTxtColorRow.localTextPrefix; }
        protected getService() { return LookupTxtColorService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}